window.addEventListener(
  'unhandledrejection',
  (e) => {
    console.error('[Unhandled Rejection]', e.reason)
  },
  false,
)

import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import 'remixicon/fonts/remixicon.css'
import { render } from 'solid-js/web'
import { lazy, Show } from 'solid-js'
import 'flatpickr/dist/flatpickr.min.css'
import './index.css'
import '@lib/styles/components/form-field.scss'
import '@lib/styles/components/checkbox.scss'
import account, { setProductLine, hasRbacError } from '@lib/auth/account'
import Login from '@lib/auth/Login'
import Logo from './assets/logo.svg'
import { CURRENT_PRODUCT_LINE } from './productLine'
import RbacError from './pages/RbacError'
import { sweepWorkspaceStorage } from './pages/sql-workplace/utils/storage-sweep'

// 開機掃除 SQL Workplace 的持久化殘留：清掉「不屬於目前登入者」的 key
// （登出後 reload 停在登入頁時 account 無 code → 全清；換帳號登入 → 清掉前一位的）。
// 資訊隔離考量（2026-07-17 定案）；後端 options 有備份，登入後 hydrate 會還原自己的狀態。
sweepWorkspaceStorage(account().code)
setProductLine(CURRENT_PRODUCT_LINE)

import dayjs from 'dayjs'
import UTC from 'dayjs/plugin/utc'
import Timezone from 'dayjs/plugin/timezone'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import IsoWeek from 'dayjs/plugin/isoWeek'

const App = lazy(() => import('./App.jsx'))

dayjs.extend(UTC)
dayjs.extend(Timezone)
dayjs.extend(LocalizedFormat)
dayjs.extend(IsoWeek)

const root = document.getElementById('root')

render(
  () => (
    <Show when={account().username} fallback={<Login appName="BI" logo={Logo} enableTOTP={true} brandName="ONION" />}>
      <Show when={!hasRbacError()} fallback={<RbacError />}>
        <App />
      </Show>
    </Show>
  ),
  root,
)
